<template>
  <div>
   <div class="searchBox">
    <div class="searchLeft">
      <el-date-picker
       size="medium"
        v-model="searchForm.startTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsStart"
        placeholder="请选择开始时间">
      </el-date-picker>
      <el-date-picker
        size="medium"
        v-model="searchForm.endTime"
        type="date"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptionsEnd"
        placeholder="请选择结束时间">
      </el-date-picker>
      <el-button size="medium" type="primary" icon="el-icon-search" @click="getTableList">搜索</el-button>
      <a :href="url+'/userBalance/usdtBalance/summary/export?startTime='+searchForm.startTime + '&&endTime='+searchForm.endTime" style="margin-left:20px">
         <el-button size="medium" type="warning" icon="el-icon-folder-opened">导出</el-button>
      </a>
    </div>
   </div>
   <el-table
    border
    :data="tableData"
    height="73vh"
    style="width: 100%">
    <el-table-column
      width="120"
      prop="date"
      label="时间">
    </el-table-column>
    <el-table-column
      prop="hicoinTusdt"
      label="APP充提USDT">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.hicoinTusdt),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="hicoinTrx"
      label="APP充提TRX">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.hicoinTrx),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="binanceUsdt"
      label="币安主">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.binanceUsdt),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="binanceSubUsdt"
      label="币安子">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.binanceSubUsdt),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="kucoinUsdtBalance"
      label="Kucoin">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(Number(scope.row.kucoinUsdtBalance),4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="userUsdtBalance"
      label="客户(USDT)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.userUsdtBalance,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="companyUsdtBalance"
      label="公司(USDT)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.companyUsdtBalance,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column
      prop="totalUsdtBalance"
      label="总资产(USDT)">
      <template slot-scope="scope">
        <span>{{$selfFunc.toNonExponential(scope.row.totalUsdtBalance,4)}}</span>
      </template>
    </el-table-column>
    <el-table-column fixed="right" label="操作" align="center" prop="time" width="100">
      <template slot-scope="scope">
         <el-button size="mini" type="primary"  v-if="scope.row.editable" @click="setOpen(scope.row)"><i class="el-icon-edit" style="margin-right:3px;"></i>编辑</el-button>
      </template>
    </el-table-column>
  </el-table>
  <div class="pageBox" v-if="totalNum > 0">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[16, 32, 50, 60]"
        :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pickerOptionsStart: {
        disabledDate: time => {
          let endDateVal = this.searchForm.endTime;
          if (endDateVal) {
            return time.getTime() > new Date(endDateVal).getTime();
          }
        }
      },
      pickerOptionsEnd: {
        disabledDate: time => {
          let beginDateVal = this.searchForm.startTime;
          if (beginDateVal) {
            return (time.getTime()<new Date(beginDateVal).getTime()-1*24*60*60*1000);
          }
        }
      },
      totalNum:0,
      searchForm:{
        page:1,
        pageSize:16,
        startTime: '',
        endTime: '',
      },
      tableData: [],
      url: window.g.host
    };
  },
  created() {
    this.getTableList()
  },
  methods: {
    setOpen(row) {
      this.$prompt('修改Kucoin值', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputValue: row.kucoinUsdtBalance
      }).then(async ({ value }) => {
        console.log(value)
        let data = {
          id: row.id,
          kucoin: value
        }
        let res = await this.$http.updateUsdtBalance({...data});
        if (res) {
          this.$message({
            type: 'success',
            message: '修改成功'
          });
          this.getTableList()
        }
       
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消输入'
        });       
      });
    },
    async getTableList(val){
      if(val){
        this.searchForm.page=1;
      }
       let res = await this.$http.usdtBalanceList({...this.searchForm});
        if (res) {
          this.tableData=res.data.list
          console.log(res.data)
          this.totalNum=Number(res.data.totalSize)
        }
    },
    handleSizeChange(val) {
      this.searchForm.page = 1;
      this.searchForm.pageSize = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getTableList();
    }
  }
};
</script>
<style scoped>
.unit{
  position: absolute;
  right: 10px;
  color:#999;
}
</style>
